module.exports = function() {
  return new Worker(__webpack_public_path__ + "b8bc569297d72bd638f1.worker.js");
};